
import React, { useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/SetPassword.css";
import { useDispatch, useSelector } from "react-redux";
import { GET_USER_FORGOT_AUTH_REQUEST } from "../store/Actions/Actions";

function ResetAuth() {
  const LENGTH = 6;
  const inputsRef = useRef([]);
  const [boxErrors, setBoxErrors] = useState(Array(LENGTH).fill(false));
  const [formError, setFormError] = useState("");
    const dispatch = useDispatch();
  const FormReduxData = useSelector(_=>_?.forgotPassword?.forgotPasswordData)
  const FormAuthData = useSelector(_=>_?.forgotPassword)
    const isLoading = useSelector(_=>_?.forgotPassword?.isLoading)

  console.log(FormReduxData);
  

  const handleChange = (idx, e) => {
    // keep only one digit
    e.target.value = (e.target.value || "").replace(/\D/g, "").slice(0, 1);

    // clear error for this box if it now has a value
    setBoxErrors((prev) => {
      const next = [...prev];
      next[idx] = !e.target.value; // true if still empty
      return next;
    });
    if (e.target.value && idx < LENGTH - 1) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handlePaste = (idx, e) => {
    const text = (e.clipboardData.getData("text") || "")
      .replace(/\D/g, "")
      .slice(0, LENGTH);
    if (!text) return;
    e.preventDefault();

    const nextErrors = [...boxErrors];

    for (let i = 0; i < text.length && idx + i < LENGTH; i++) {
      const el = inputsRef.current[idx + i];
      if (el) {
        el.value = text[i];
        nextErrors[idx + i] = false; // filled -> no error
      }
    }
    setBoxErrors(nextErrors);

    const next = Math.min(idx + text.length, LENGTH - 1);
    inputsRef.current[next]?.focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === "Backspace" && !e.target.value && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // collect digits
    const values = inputsRef.current.slice(0, LENGTH).map((el) => (el?.value || "").trim());
    const emptyIdx = values.map((v, i) => (!v ? i : -1)).filter((i) => i !== -1);

    if (emptyIdx.length > 0) {
  
      setBoxErrors((prev) => {
        const next = Array(LENGTH).fill(false);
        emptyIdx.forEach((i) => (next[i] = true));
        return next;
      });
      setFormError("Please enter the 6-digit code.");

      inputsRef.current[emptyIdx[0]]?.focus();
      return;
    }


    setFormError("");
    setBoxErrors(Array(LENGTH).fill(false));
    const code = values.join("");

   dispatch({type:GET_USER_FORGOT_AUTH_REQUEST,payload:{...FormReduxData,otp:code}})

  };

  console.log(FormAuthData);
  

  return (
    <div className="set-password-container">
      <div className="header move-top forgot-password-header">
       <Link to="/"><img src="../assets/images/logo.png" alt="Logo" className="logo" /></Link>

        <h2 className=" text-center fw-lighter text-body-secondary">Reset Your Password</h2>
      </div>

      <div className="password-form-1">
        <p className="subtitle">Please enter the OTP sent to your Email address</p>

        <form className="budget-form" onSubmit={handleSubmit}>
          <div className="form-group flex-item">
            

            {/* add has-error on the row if any box in error */}
            <div className={`d-flex gap-2 ${boxErrors.some(Boolean) ? "has-error" : ""}`}>
              {Array.from({ length: LENGTH }).map((_, i) => (
                <input
                  key={i}
                  type="text"
                  inputMode="numeric"
                  className={`form-control text-center otp-box ${boxErrors[i] ? "is-invalid" : ""}`}
                  maxLength={1}
                  aria-label={`Digit ${i + 1}`}
                  placeholder="•"
                  ref={(el) => (inputsRef.current[i] = el)}
                  onChange={(e) => handleChange(i, e)}
                  onKeyDown={(e) => handleKeyDown(i, e)}
                  onPaste={(e) => handlePaste(i, e)}
                />
              ))}
            </div>
          </div>

          {/* error message below boxes (same style as your ForgotPassword) */}
          {formError && (
            <div className="alert" role="alert">
              {formError}
            </div>
          )}

           {FormAuthData?.auth_error && <div className="alert" role="alert">
                 Something went wrong! Please try again in a moment.
                </div>}


          <button className="btn btn-primary w-100 mt-3" type="submit">
            Confirm
          </button>
        </form>

         {isLoading && (
              <div className='loading-login'>
            <img className='loading-login-img' src="/assets/images/l2.gif" />
          </div>
              )}
      </div>

      <span className="login-footer">
        © {new Date().getFullYear()} ProjeX. All rights reserved. 
      </span>

    </div>
  );
}

export default ResetAuth;
